import * as async from "async";
import $ from "jquery";
import Sortable from "sortablejs";
import * as _ from "underscore";

import * as modalDialog from "modalDialog";
import * as mustcache from "mustcache";
import * as wordExport from "shared/wordExport";

let remoteUserWords;
let models;
let exampleOutput;

/** @type {any} */
let dialog;
let delimiter;

const allFields = [
  { name: "contextBlanked", displayName: "Context (with blank)" },
  { name: "frequency", displayName: "Word Frequency*" },
  { name: "translation", displayName: "Translation" },
  {
    name: "contextWithOriginal",
    displayName: "Context (with original word)",
  },
  { name: "contextAnkiClozeOriginal", displayName: "Context (Anki cloze)" },
  {
    name: "contextAnkiClozeBoth",
    displayName: "Context (Anki cloze with translation)",
  },
  { name: "dateCreated", displayName: "Date Added" },
  { name: "source", displayName: "Source", tooltip: "Document Title" },
  { name: "sourceUrl", displayName: "Source URL", tooltip: "URL" },
  {
    name: "alternativeWords",
    displayName: "Alternatives",
    tooltip: "Synonyms",
  },
  {
    name: "alternativeTranslations",
    displayName: "Alternative Translations",
  },
  {
    name: "contextWithTranslation",
    displayName: "Context (with translation)",
  },
  { name: "word", displayName: "Original" },
];

export const show = (_remoteUserWords, _models) => {
  remoteUserWords = _remoteUserWords;
  models = _models;

  const templateData = _.extend(remoteUserWords.selectionModel.toJSON(), {
    queryParams: $.param(remoteUserWords.selectionModel.getQuery()),
  });

  // set initial delimiter state
  const exportSettings = models.user.get("exportSettings");

  const currentFieldNames = (exportSettings && exportSettings.fields) || [
    "contextWithTranslation",
    "word",
  ];
  templateData.currentFields = _.map(currentFieldNames, (fieldName) =>
    _.findWhere(allFields, { name: fieldName })
  );

  templateData.unusedFields = [];
  _.each(allFields, (field) => {
    if (!_.contains(currentFieldNames, field.name)) {
      templateData.unusedFields.push(field);
    }
  });

  dialog = $(mustcache.render("exportDialog", templateData));

  if (exportSettings) {
    if (exportSettings.delimiter === ";") {
      dialog.find('[name="delimiter"][value=";"]').prop("checked", true);
    } else if (exportSettings.delimiter !== "\t") {
      dialog.find('[name="delimiter"][value="other"]').prop("checked", true);
      dialog.find(".otherDelimiter").val(exportSettings.delimiter);
    } else {
      dialog.find('[name="delimiter"][value="tab"]').prop("checked", true);
    }
  }

  Sortable.create(dialog.find("#unusedFields")[0], {
    animation: 150,
    group: "exportFields",
    onUpdate: () => {
      renderPreview();
    },
    onMove: () => {
      renderPreview();
    },
  });

  Sortable.create(dialog.find("#currentFields")[0], {
    animation: 150,
    group: "exportFields",
    onUpdate: () => {
      renderPreview();
    },
    onMove: () => {
      renderPreview();
    },
  });

  dialog
    .find("#delimiter")
    .val(";")
    .keyup(() => {
      renderPreview();
    });

  exampleOutput = dialog.find("#exampleOutput");
  modalDialog.show(dialog, { title: "exportWords" });
  renderPreview();

  dialog.find("#doExportButton").click(() => {
    window.location.href = "/api/export.txt?" + getURLQuery();

    models.user.set("exportSettings", {
      delimiter: delimiter,
      fields: selectedFields(),
    });
  });

  dialog.find(".exportToBrowserTab").click((event) => {
    event.preventDefault();
    window.open("/api/export?" + getURLQuery(), "_blank");
  });

  dialog.find('[name="delimiter"]').change(() => {
    renderPreview();
  });
  dialog.find(".otherDelimiter").keyup(() => {
    renderPreview();
  });
};

var getURLQuery = () => {
  const query = {
    query: JSON.stringify(remoteUserWords.selectionModel.getQuery()),
    fields: JSON.stringify(selectedFields()),
    delimiter: delimiter,
  };
  return $.param(query);
};

var selectedFields = () => {
  const fields = [];

  dialog.find("#currentFields li").each(function () {
    const $this = $(this);
    fields.push($this.attr("data-field"));
  });

  return fields;
};

var renderPreview = () => {
  const firstWords = remoteUserWords.selectionModel.getFirstSelected(3);
  let output = [];

  const delimiterRadioValue = dialog.find('[name="delimiter"]:checked').val();
  if (delimiterRadioValue === "other") {
    dialog.find(".otherDelimiter").removeAttr("disabled");

    const otherDelimiter = dialog.find(".otherDelimiter").val();

    if (otherDelimiter === "") {
      dialog.find(".otherDelimiter").addClass("invalid");
      return;
    } else {
      dialog.find(".otherDelimiter").removeClass("invalid");
    }

    delimiter = otherDelimiter;
  } else {
    dialog.find(".otherDelimiter").removeAttr("invalid");
    dialog.find(".otherDelimiter").attr("disabled", "disabled");

    if (delimiterRadioValue === "tab") {
      delimiter = "\t";
    } else {
      delimiter = delimiterRadioValue;
    }
  }

  // ensure we have all contexts
  async.series([
    (callback) => {
      async.each(
        firstWords,
        (word, firstWordCallback) => {
          if (word.has("context")) {
            firstWordCallback();
          } else {
            word.fetch({
              success: function () {
                firstWordCallback();
              },
            });
          }
        },
        () => {
          callback();
        }
      );
    },
    (callback) => {
      const fields = selectedFields();
      _.each(firstWords, (word) => {
        output = output.concat(
          wordExport.formatWord(word.toJSON(), fields, delimiter)
        );
      });

      exampleOutput.children().remove();
      _.each(output, (line) => {
        exampleOutput.append($("<li/>").append($("<pre/>").text(line)));
      });
      callback();
    },
  ]);
};
